<template>
  <div class="academy academy__hero">
    <HeroText
      :heroH1="''"
      :heroH2="currentPage.fields.title"
      :heroP="currentPage.fields.intro"
      :internalPage="true"/>
    <!-- tabs area -->
    <div class="glaxi-menu__categories__tabs academy__tabs">
      <ul>
        <li
          @click="$_activeTab('All')"
          :class="{'glaxi-menu__categories__tabs__li--active': activeTab === 'All'}">
          {{ $t('academy.tab01') }}
        </li>
        <li
          @click="$_activeTab('Ricette')"
          :class="{'glaxi-menu__categories__tabs__li--active': activeTab === 'Ricette'}">
          {{ $t('academy.tab02') }}
        </li>
        <li
          @click="$_activeTab('Live from')"
          :class="{'glaxi-menu__categories__tabs__li--active': activeTab === 'Live from'}">
          {{ $t('academy.tab03') }}
        </li>
        <li
          @click="$_activeTab('Tips&Tricks')"
          :class="{'glaxi-menu__categories__tabs__li--active': activeTab === 'Tips&Tricks'}">
          {{ $t('academy.tab04') }}
        </li>
      </ul>
    </div>
    <!-- listings columns -->
    <div class="blog-posts-listings">
      <PostsList
        v-if="typeof chunkArray[0] !== 'undefined'"
        :list="chunkArray[0]" />
      <PostsList
        v-if="typeof chunkArray[1] !== 'undefined'"
        :list="chunkArray[1]"
        :rellaxSpeed="1" />
      <PostsList
        v-if="typeof chunkArray[2] !== 'undefined'"
        :list="chunkArray[2]" />
    </div>

    <!-- load more -->
    <div 
      v-if="!maxLoadReached"
      class="blog-posts-load-more">
      <span @click="$_loadMore">
        {{ $t('academy.loadMore') }}
      </span>
    </div>

    <!-- banner chef -->
    <div class="banner-chef">
      <div class="banner-chef__container">
        <div class="banner-chef__container--img">
          <img :src="chefImage" alt="Chef Franco Ruggero" width="506px" height="388px">
        </div>
        <div class="banner-chef__container--content">
          <p class="banner-chef__container--content__title">
            Chef Franco Ruggero
          </p>
          <p class="banner-chef__container--content__text" v-html="$t('academy.chefText')"></p>
        </div>
      </div>
    </div>

    <StayUpToDate />
    <glaxiFooter/>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { splitEvery, transpose } from 'ramda'

import HeroText from '@/components/HeroText/HeroText.vue'
import PostsList from '@/components/PostsList/PostsList.vue'
import StayUpToDate from '@/components/StayUpToDate/StayUpToDate.vue'
import GlaxiFooter from '@/components/GlaxiFooter/GlaxiFooter.vue'

import matchMedia from '@/mixins/matchMedia.js'

export default {
  name: 'Academy',
  mixins: [matchMedia],
  components: {
    HeroText,
    PostsList,
    StayUpToDate,
    GlaxiFooter
  },
  props: {
    currentPage: {
      type: Object,
      required: false
    }
  },
  data: () => ({
    loading: true,
    activeTab: 'All',
    maxItems: 10,
    chefImage: require('@/assets/academy/ruggero-chef.jpg')
  }),
  computed: {
    ...mapGetters('contentful', [
      'blogPosts'
    ]),
    ...mapGetters([
      'lang'
    ]),
    getViewPort: {
      get () {
        return this.matchMedia === 'medium' || this.matchMedia === 'small'
      }
    },
    maxLoadReached: {
      get () {
        if (this.activeTab === 'All') return this.maxItems >= this.blogPosts.length
        else return this.maxItems >= this.blogPosts.filter(blogPost => blogPost.fields.category === this.activeTab).length
      }
    },
    slidePosts: {
      get () {
        if (this.loading) return undefined
        if (this.activeTab === 'All') return this.blogPosts.slice(0, this.maxItems)
        if (this.activeTab !== 'All') return this.blogPosts.filter(blogPost => blogPost.fields.category === this.activeTab).slice(0, this.maxItems)
        return undefined
      }
    },
    chunkArray: {
      get () {
        // console.log(this.blogPosts)
        if (this.slidePosts === undefined || this.slidePosts.length === 0) return [[], [], []]
        if (this.matchMedia === 'medium' || this.matchMedia === 'small') return transpose(splitEvery(2, this.slidePosts))
        return transpose(splitEvery(3, this.slidePosts))
      }
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    ...mapActions('contentful',
      ['loadBlogPosts']
    ),
    $_activeTab (selectedTab) {
      this.activeTab = selectedTab
    },
    $_loadMore () {
      this.maxItems = this.maxItems + 9
    },
    async loadData () {
      this.loading = true
      try {
        await Promise.all([this.loadBlogPosts()])
        this.loading = false
      } catch (e) {
        // TODO sentry
      }
    }
  }
}
</script>

<style lang="scss">
  @import "./academy.scss";
</style>
